<div class="footer_container">
  <div class="footer">
    Copyright ©2001 - {{currentYear}} Engage. All rights reserved. <a href="https://engagecrm.ai/terms-of-use" target="_blank">Terms of use.</a>
  </div>
</div>
